import React from "react";

import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";

import {PostToPbx, PostToPbx2} from "../../../api/http-post";
import {
    Switch,
    PageHeader,
    Descriptions, Col, Form, Row, Button, Select, Table
} from "antd";
import {GetUserToken} from "../../../api/token";
import GenericComboBox from "../../../components/General/GenericComboBox";
import {fetchDataEntity} from "../../../api/entity-data";
import {SortDataDesc} from "../../../api/fn";

const {Option} = Select;
class WorkboardCallcentreQueueStatusPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Queues: [],
            isLoading: false,
            component: "list",
            selectedCompany:"",
            selectedEntity:"",
            selectedQueue:"",
            Results:[],
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
        await this.loadData("AllocationUserViop", "Voips", (data) => this.fetchVoipQueue(data));
        await this.fetchQueueStatus();
    }

    loadInitialData = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        let userInfo = GetUserToken();
        let paramsCompany = {};
        if (userInfo.Role !== "super") {
            paramsCompany = [
                {key: "CustomerNumber", val: userInfo.Org, type: "string"},
            ];
        }
        await this.fetchData("companies", "Companies", paramsCompany, null);
    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });
    }
    fetchQueueStatus=async ()=>{
        let _this = this;
        let endpoint = "/desk/queue/status";
        this.setState({
            isLoading: true,
        })
        let post={}
        await PostToPbx(post, endpoint, async (data) => {
            console.log("fetchQueueStatus loadInitialData response > ", post, " > ", data);
            await _this.setState({
                Results: data.RESULT
            })
        });
    }
    fetchData = async (table, stateKey, params, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = params;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })
        await PostToPbx(post, endpoint, async (data) => {
            let res = [];
            if (data !== null) {
                res = data.RESULT;
            }
            await _this.setState({
                [stateKey]: res
            });
            console.log("fetchData response === > ", table, " > ", post, data);
            if (feedback !== null) {
                feedback(res)
            }
        });
    }
    loadData = async (targetEntity, stateKey, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("WorkboardCallcentreQueueStatusPage loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
            feedback(data.RESULT);
        });
    }
    PostExternal = async (hub, endpoint, stateKey, feedback) => {
        await PostToPbx2(hub, endpoint, async (dataIn) => {
            let data = [];
            if (dataIn !== null) {
                data = dataIn.RESULT;
            }
            console.log("PostExternal > ",endpoint + " response ---> ", endpoint, " > ", hub, data);
            feedback(data)
        });
    }
    fetchVoipQueue = async (data) => {
        let _this = this;
        let hub = {};
        await this.PostExternal(hub, "/manager/entity/list/queues", "Queues", (data) => {
            let ls = [];
            for (let i in data) {
                let row = data[i];
                ls.push(row)
            }
            _this.setState({
                Queues: ls,
            })
        })
    }
    getInfoLogin = () => {
        let user = GetUserToken();
        let username = user.Username, role = user.Role, org = user.Org, outbound = '';
        for (let i in this.state.Voips) {
            let row = this.state.Voips[i];
            if (row.agent === username) {
                org = row.companycode;
                outbound = row.outboundnumber
            }
        }
        return {org, role, username, outbound}
    }

    renderQueueSelection = () => {
        let ls = [];
        let user = GetUserToken();
        let {org,role}=this.getInfoLogin()
        for (let i in this.state.Voips) {
            let row = this.state.Voips[i];
            if (row.user === user.Username) {
                org = row.companycode;
            }
        }



        for (let i in this.state.Queues) {
            let row = this.state.Queues[i];
            if (org === row.Org) {
                ls.push(row)
            }
        }
        console.log("renderQueueSelection555 > ",org," > ",this.state.Voips)

        return (
            <Col span={4}>
                <GenericComboBox
                    displayConditionStateKey={this.state.component}
                    displayConditionStateValue={"list"}
                    data={ls}
                    label={"Select Queue"}
                    name={"selectedQueue"}
                    message={"Please select your queue!"}
                    handleChange={this.handleChangeCompany}
                    getValue={this.state.selectedQueue}
                    recordOptionKey={"Name"}
                    recordOptionValue={"Name"}
                    recordOptionDisplay={"Name"}
                    noCondition={true}
                />
            </Col>
        )
    }

    renderCompaniesSelection = () => {

        return (
            <Col span={4}>
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"customernumber"}
                recordOptionValue={"customernumber"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
            </Col>
        )
    }
    renderResult=()=>{

        let tmps = SortDataDesc("Holdtime",this.state.Results);
        let columns=[
            {dataIndex: "Queue", title: "Queue Name"},
            {dataIndex: "Holdtime", title: "Hold time"},
            {dataIndex: "Calls", title: "Current"},
            {dataIndex: "Completed", title: "Completed"},
            {dataIndex: "Abandoned", title: "Abandoned"},
            {dataIndex: "Weight", title: "Weight"},
            {dataIndex: "ServiceLevel", title: "Level"},
            {dataIndex: "ServicelevelPerf", title: "Level-Perf."},
            {dataIndex: "Max", title: "Max"},
        ]

        let {org,role}=this.getInfoLogin()
        let ls=[];
        if(role==="super"){
            ls = tmps;
        }else{
            for(let i in tmps){
                let row=tmps[i];
                if(row.Org!==org){continue}
                ls.push(row)
            }
        }


        return(
            <div style={{minWidth: "100%", padding: 5,}}>
            <Table
                columns={columns}
                dataSource={ls}
                bordered
                /* title={() => 'Period'}*/
                /*footer={() => 'Footer'}*/
            />
            </div>
        )
    }
    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title={"Queue Status".toLocaleUpperCase()}
                        subTitle="Select refresh to get update status"
                        extra={[
                            <div style={{marginRight: 10, minWidth: "100%", paddingLeft: 20}}>
                                <Button onClick={()=>this.fetchQueueStatus()}>Refresh</Button>
                            </div>,
                        ]}
                        style={{border: "1px solid rgb(235, 237, 240)"}}
                    >

                    </PageHeader>

                    <div style={styles.containerBox}>

                        <Row gutter={16}>
                            {this.renderCompaniesSelection()}
                            {this.renderQueueSelection()}
                        </Row>

                    </div>
                    {this.renderResult()}

                </div>
            </Page>
        )
    }

}


export default Connector(WorkboardCallcentreQueueStatusPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    card: {
        minHeight: 400,
    },
    containerBox: {
        background: "#ececec",
        marginTop: 25,
        minHeight: 35,
        maxHeight: 35,
    },
    box: {
        minHeight: 400,
        margin: 10
    },

}
